<template>
  <b-form-group
    :label="$props.label"
    :label-for="fieldId"
    label-class="mb-1 small"
    class="w-100 px-2"
  >
    <b-form-select
      v-model="selected"
      :options="$props.options"
      :id="fieldId"
      size="sm"
    >
      <template #first>
        <b-form-select-option :value="undefined" disabled
          >Select filter</b-form-select-option
        >
      </template>
    </b-form-select>
  </b-form-group>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { kebabCase } from 'lodash-es'

export default defineComponent({
  name: 'BDXStatusModalFiltersDropdown',
  props: {
    value: String,
    label: String,
    options: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const selected = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    const fieldId = computed(() => {
      const id = kebabCase(props.label)

      return `global-umr-filter--${id}`
    })

    return {
      selected,

      fieldId
    }
  }
})
</script>

<style scoped>
.form-group >>> .custom-select {
  min-width: 110px;
}
</style>
